export interface ContactInfo {
  email: string;
  phone: string;
  address: string;
  location: string;
}

export interface ContactHeadlineData {
  title: string;
}

export interface FooterData {
  copyright: string;
}

export interface ContactContent {
  headline: ContactHeadlineData;
  contactInfo: ContactInfo;
  footer: FooterData;
}

export const CONTACT_CONTENT: ContactContent = {
  headline: {
    title: "Contact"
  },
  contactInfo: {
    email: "info@soloop.dev",
    phone: "+383 48 120 278",
    address: "1 Tetori, Prishtinë, 10000,  Kosovë",
    location: "1 Tetori, Prishtinë, 10000, Kosovë"
  },
  footer: {
    copyright: "2025 Soloop L.L.C. All rights reserved."
  }
}; 